import { useEffect, useRef } from "react";

// Closes a dialog once its save has finished without an error: the store
// says when the API answered, and with which error code, if any.
const useCloseWhenSaved = (saving, errorCode, onHide) => {
  const wasSaving = useRef(saving);

  useEffect(() => {
    if (wasSaving.current && !saving && !errorCode) {
      onHide();
    }
    wasSaving.current = saving;
  }, [saving, errorCode, onHide]);
};

export default useCloseWhenSaved;
